import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { StingrayAuthenticationService } from '@app/core/authentication/stingray-authentication.service';
import { Customer } from '@app/core/stingray-api/models';
import { environment } from '@env/environment';
import { CreateDialogCofiguration } from './create-dialog-cofiguration';
import { CreateByVirComponent } from '../create-by-vir/create-by-vir.component';
import { CreateCollaborationComponent } from '../create-collaboration/create-collaboration.component';
import { CreateCompanyComponent } from '../create-company/create-company.component';
import { CreatePersonComponent } from '../create-person/create-person.component';

import { MatTabNav, MatTabLink } from '@angular/material/tabs';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'unite-create-dialog',
    templateUrl: './create-dialog.component.html',
    styleUrls: ['./create-dialog.component.scss'],
    imports: [MatDialogTitle, TranslateModule, MatIconButton, MatDialogClose, MatIcon, MatTabNav, MatTabLink, MatDialogContent, CreatePersonComponent, CreateCompanyComponent, CreateCollaborationComponent, CreateByVirComponent]
})
export class CreateDialogComponent implements OnInit {

  collaborationMemberId: string;
  isProductionEnvironment = environment.production;
  isVirEnabledAccount = false;
  type = 'Person';

  constructor(
    private dialogRef: MatDialogRef<CreateDialogComponent>,
    private stingrayAuthenticationService: StingrayAuthenticationService,
    @Inject(MAT_DIALOG_DATA) public config: CreateDialogCofiguration
  ) {
    if (config) {
      this.type = config.type;
      this.collaborationMemberId = config.collaborationMemberId;
      console.log('collaboration member id', config.collaborationMemberId);
    }
  }

  ngOnInit(): void {
    this.isVirEnabledAccount = this.stingrayAuthenticationService.isVirEnabledAccount();
  }

  newCustomer(customer: Customer): void {
    this.dialogRef.close(customer);
  }

  close(): void {
    this.dialogRef.close();
  }

  setType(type: string): void {
    this.type = type;
  }
}
